import { SVGProps } from 'react'

export const CheckAll = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 17 16" {...props}>
    <path
      fill="#005FFF"
      fillRule="evenodd"
      d="M1.537 7.528a.673.673 0 01.948 0l2.682 2.667a.664.664 0 010 .943.673.673 0 01-.948 0L1.537 8.47a.664.664 0 010-.943zM6.23 8.195a.673.673 0 01.948 0l2.01 2a.664.664 0 010 .943.673.673 0 01-.947 0l-2.011-2a.664.664 0 010-.943z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#005FFF"
      fillRule="evenodd"
      d="M10.53 4.862a.664.664 0 010 .943l-5.363 5.333a.673.673 0 01-.948 0 .664.664 0 010-.942l5.363-5.334a.673.673 0 01.948 0zM14.552 4.862a.664.664 0 010 .943L9.19 11.138a.673.673 0 01-.948 0 .664.664 0 010-.942l5.363-5.334a.673.673 0 01.948 0z"
      clipRule="evenodd"
    ></path>
  </svg>
)
